import { Suspense, lazy } from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import WhatsAppButton from "@/components/WhatsAppButton";

// Skeleton Loader
import { TourDetailSkeleton } from "@/components/SkeletonLoader";

// Lazy Load Pages
const Index = lazy(() => import("./pages/Index"));
const Contact = lazy(() => import("./pages/Contact"));
const TipsAdvice = lazy(() => import("./pages/TipsAdvice"));
const DayTours = lazy(() => import("./pages/DayTours"));
const HolidayPackages = lazy(() => import("./pages/HolidayPackages"));
const TourDetail = lazy(() => import("./pages/TourDetail"));
const TourReviewsPage = lazy(() => import("./pages/TourReviewsPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const LoadingFallback = () => (
  <div className="container-main pt-32 pb-16">
    <TourDetailSkeleton />
  </div>
);

import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";

import GoogleAnalytics from "@/components/GoogleAnalytics";

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <WhatsAppButton />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <GoogleAnalytics />
          <SpeedInsights />
          <Analytics />
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/tips-advice" element={<TipsAdvice />} />
              <Route path="/day-tours" element={<DayTours />} />
              <Route path="/day-tours/:city" element={<DayTours />} />
              <Route path="/holiday-packages" element={<HolidayPackages />} />
              <Route path="/tour/:slug" element={<TourDetail />} />
              <Route path="/tour/:slug/reviews" element={<TourReviewsPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
